<template>
	<div class='List'>
		<h3 class="title">
			图文列表
		</h3>
		<div class="item_box">
			<div class="item" v-for="(item, index) in page_data" :key="index">
				<div class="info_time">
					<span><i class="iconfont">&#xe67f;</i> {{item.release_time, 'Y年M月D日 h:m:s'| formatDates}}</span>
				</div>

				<div class="content">
					<img v-if="item.uploadImgId_url" :src="item.uploadImgId_url" alt="">
					<div class="desc" v-html="item.text_content"></div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
import ShareServiceList from "../../../service/ShareServiceList";
import { formatDates } from '@/assets/js/date.js';

export default {
	name: "List",
	components: {},
	data() {
		return {
			page_data: null,
		};
	},
	/* 时间过滤 */
    filters: {
      formatDates
    },
	async mounted() {
		const list = await new ShareServiceList().listData(
			this.$route.query.id
		);

		this.page_data = list;
	},
	methods: {
		onPlay(e) {
			const dataIndex = e.target.dataset.ref;

			Object.keys(this.$refs).forEach((key) => {
				if (key.indexOf("VueAliplayerV2") > -1 && key != dataIndex) {
					this.$refs[key][0].pause();
				}
			});
		},
		handleVideoReady(e) {
			console.log("e: ", e);
		},
	},
};
</script>
<style lang='stylus' scoped>
.List
	width 100%
	min-height 100vh
	padding-top: 0.2rem
	padding-bottom: 0.8rem

	.title
		width calc(100% - 1.34rem)
		text-align left
		border-left 5px solid #0098f9
		margin 0.34rem auto
		padding-left 10px
		overflow hidden
		font-size 32px
		color #333
		font-weight 600
		line-height 50px

		.right_status
			background #fe6333
			padding 2px 10px
			border-radius 10px
			color #FFF
			display block
			font-size 24px
			float right

	.item_box
		width calc(100% - 1.34rem)
		margin auto
		padding-top 0.34rem
		box-shadow 3px 2px 15px #999

		.item
			width 100%
			border-left 2px solid #1994fb /* no */

			.info_time
				width 100%

				span
					background #1994fb
					padding 4px 30px 4px 10px
					color #FFF
					border-top-right-radius 20px
					border-bottom-right-radius 20px
					font-size 28px
					display inline-block

					i
						font-size 28px

			.content
				// text-indent 2em
				width calc(100% - 0.8rem)
				margin auto
				padding 0.4rem 0

				>>> img, p
					width 100%
					margin 0.2rem auto

				.desc
					font-size 0.32rem
					font-family Microsoft YaHei
					font-weight 400
					line-height 0.64rem
					color #353535
					margin-top 0.4rem
					text-align: justify


@media (min-width 750px)
	body
		width 750px
		margin auto
		overflow hidden
</style>
